import {PagingMetadataRestDto} from "@/api/pharma-cpc-product-mgmt/models";
import {
    CatalogProductWithImageOverviewRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/CatalogProductWithImageOverviewRestDtoModel";

export class PagedCatalogProductWithImageOverviewResultsRestDtoModel {
    paging_metadata?: PagingMetadataRestDto|null;
    results: CatalogProductWithImageOverviewRestDtoModel[];

    constructor(paging_metadata: PagingMetadataRestDto | null, results: CatalogProductWithImageOverviewRestDtoModel[]) {
        this.paging_metadata = paging_metadata;
        this.results = results;
    }

    public static createWithDefaults(): PagedCatalogProductWithImageOverviewResultsRestDtoModel {
        return new this(null, []);
    }
}
